"use client";

import InvoicePaymentModal from "@/app/(general-header)/subscription/invoice/invoicePaymentModal";
import { OnCloseReason } from "@/app/(general-header)/subscription/interfaces";
import { publishModalData, publishModalProps, publishModalVisibility } from "@/app/redux/features/modal/modalSlice";
import type { AppDispatch } from "@/app/redux/store";

export function openInvoicePaymentModal(
  dispatch: AppDispatch,
  invoiceId: string,
  options?: {
    onClose?: (_reason?: OnCloseReason) => void;
    onError?: (_errorCode: "pay_iframe_error" | "create_session_error") => void;
  }
) {
  dispatch(publishModalProps({ withOverlay: false }));
  dispatch(
    publishModalData({
      modalData: <InvoicePaymentModal invoiceId={invoiceId} onClose={options?.onClose} onError={options?.onError} />,
    })
  );
  dispatch(publishModalVisibility({ isOpen: true }));
}
